import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import {
  EyeOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import {
  Button,
  Dropdown,
  Form,
  Layout,
  MenuProps,
  message,
  Space,
  TableColumnsType,
  TableProps,
} from "antd";
import { useForm, useWatch } from "antd/es/form/Form";
import dayjs from "dayjs";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TableData from "../../../../../components/table-data/TableData";
import { routesConfig } from "../../../../../config/routes";
import { postCourseSearch } from "../../../../../service/course-construct";
import { getSectionByCourse, getSequenceBySection } from "../../../../../service/learning-course";
import { addUnitBankToStorage, getAllAuthor, getAllProductionUnit, getPageUnitBankPublic, getTopicFilter, removeStorage, useUnitBankToSequence } from "../../../../../service/library";
import { globalStore } from "../../../../../stores/stores";
import { formatOriginTime } from "../../../../../utils/converDate";
import AddExamCourseModal from "../bank-exam-list/AddExamModal";

type Props = {
  filterData: any;
  searchValue: string;
  setFilterData: (value: any) => void;
  setSearchValue: (value: string) => void;
  filterApplied: boolean;
  tab: string
};
const BankExamList = (props: Props) => {
  const { t } = useTranslation();
  const {
    filterData,
    searchValue,
    setFilterData,
    setSearchValue,
    filterApplied,
    tab
  } = props

  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [loading, setLoading] = useState(false);
  const [listDataExam, setListDataExam] = useState<any>();
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [courseOptions, setCourseOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [sequenceOptions, setSequenceOptions] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState<number | null>(null);
  const [isFirstTimes, setIsFirstTimes] = useState(true);
  const { personalInfo, reload } = globalStore();

  const navigate = useNavigate();
  const location = useLocation();
  const [form] = useForm();
  const [dataOptions, setDataOptions] = useState<any>({
    dataTopic: [],
    dataLevel: [
      {
        id: 3,
        name: t("Cấp Bộ", "Cấp Bộ"),
      },
      {
        id: 2,
        name: t("Cấp Trường", "Cấp Trường"),
      },
      {
        id: 1,
        name: t("Cấp Giảng viên", "Cấp Giảng viên"),
      },
    ],
    dataUnit: [],
    dataAuthor: [],
  });


  const createOptions = (record: any) => {
    const options1: MenuProps["items"] = [
      {
        key: "0",
        label: t("Thêm vào khóa học", "Thêm vào khóa học"),
      },
      {
        key: "1",
        label: !record.storageStatus ? t("Lưu trữ", "Lưu trữ") : t("Bỏ lưu trữ", "Bỏ lưu trữ"),
      },
    ];
    return options1;
  };

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "courseName,asc"
        : sorter.order === "descend"
          ? "courseName,desc"
          : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  const handleStoreBank = async (record: any) => {
    if (record.storageStatus === false) {
      try {
        await addUnitBankToStorage(record.id).then((res) => {
          if (res.status === 200) {
            message.success(t('Lưu trữ thành công!', 'Lưu trữ thành công!'));
            fetchData();
          }
        })
      } catch (error) {
        console.error(error);
      }
    }
    else {
      try {
        await removeStorage(record.id, false).then((res) => {
          if (res.status === 200) {
            message.success(t('Bỏ lưu trữ thành công!', 'Bỏ lưu trữ thành công!'));
            fetchData();
          }
        })
      } catch (error) {
        console.error(error);
      }
    }
  };


  const dataColumns: TableColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 10,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Mã đề", "Mã đề"),
      dataIndex: "code",
      key: "code",
      width: 20,
    },
    {
      title: t("Tiêu đề", "Tiêu đề"),
      dataIndex: "question",
      key: "question",
      width: 30,
    },
    {
      title: t("Số câu hỏi", "Số câu hỏi"),
      dataIndex: "totalQuiz",
      key: "totalQuiz",
      width: 20,
    },
    {
      title: t("Chủ đề", "Chủ đề"),
      dataIndex: "topic",
      key: "topic",
      width: 20,
    },
    {
      title: t("Phân cấp", "Phân cấp"),
      dataIndex: "typeProduction",
      key: "typeProduction",
      width: 20,
      render: (_: any, record) => {
        return (
          <>
            {record?.typeProduction === 1 ? (
              <>{t("Cấp giảng viên", "Cấp giảng viên")}</>
            ) : record?.typeProduction === 2 ? (
              <>{t("Cấp trường", "Cấp trường")}</>
            ) : (
              <>{t("Cấp bộ", "Cấp bộ")}</>
            )}
          </>
        );
      },
    },
    {
      title: t("Lượt dùng", "Lượt dùng"),
      dataIndex: "numberOfUse",
      key: "numberOfUse",
      width: 20,
      render: (_: any, record) => {
        return (
          <>{record?.numberOfUse ? record?.numberOfUse : 0}</>
        );
      },
    },
    {
      title: t("Đơn vị xuất bản", "Đơn vị xuất bản"),
      dataIndex: "productionUnitName",
      key: "productionUnitName",
      width: 30,
    },
    {
      title: t("Ngày cập nhật", "Ngày cập nhật"),
      dataIndex: "updateDate",
      key: "updateDate",
      width: 20,
      render: (_: any, record: any) => {
        return (
          <>
            {!isEmpty(record?.updateDate)
              ? formatOriginTime(record?.updateDate)
              : null}
          </>
        );
      },
    },
    {
      title: t("Thao tác", "Thao tác"),
      dataIndex: "action",
      key: "operation",
      render: (_, record) => {
        const location = {
          id: `${record?.id}`,
        };

        return (
          <>
            <Space>
              <a
                className="action-table"
                onClick={() => {
                  navigate(
                    `/${routesConfig.ministryContentModeration}/${routesConfig.previewExam}?id=${record?.id}`,
                    {
                      state: {
                        backUrl: `/${routesConfig.courseLibrary}/${routesConfig.bankExam}/${routesConfig.bankExamList}`,
                        mode: "0",
                        titleBreadCrumb: t("Quản lý ngân hàng đề", "Quản lý ngân hàng đề"),
                      },
                    }
                  );
                }}
              >
                <EyeOutlined />
              </a>
              <Dropdown
                menu={{
                  items: createOptions(record),
                  onClick: ({ key }) => {
                    if (key === "0") {
                      showModal(record?.id);

                    }
                    if (key === "1") {
                      handleStoreBank(record);
                    }
                  },
                }}
                placement="bottomRight"
              >
                <Button>
                  <MoreOutlined />
                </Button>
              </Dropdown>
            </Space>
          </>
        );
      },
      fixed: "right",
      width: 20,
    },
  ];

  const showModal = (bankId: number) => {
    setSelectedBankId(bankId); // Lưu bankId vào state
    fetchCourses();
    setIsModalOpen(true);
  };


  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      await callUseUnitBankToSequence(values);
      setIsModalOpen(false);
    } catch (error) {
      message.error(t("Vui lòng kiểm tra lại các trường bắt buộc.", "Vui lòng kiểm tra lại các trường bắt buộc."));
    }
  };


  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // fetch data
  const fetchData = async () => {
    setLoading(true);
    const payload = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue,
      topics: filterData.topics || [],
      dateFrom: filterData?.createDate[0] ? dayjs(filterData?.createDate[0]).toISOString() : undefined,
      dateTo: filterData?.createDate[1] ? dayjs(filterData?.createDate[1]).toISOString() : undefined,
      type: "unit_quiz",
      // sort: isEmpty(fieldSortOrder) || isEmpty(statusOrder) ? ["approvedSendDate, desc"] : [`${fieldSortOrder},${statusOrder}`],
    };

    try {
      await getPageUnitBankPublic(payload).then((res) => {
        if (res.status === 200) {
          setListDataExam(res.data?.data?.content);
          setTotalRecords(res.data?.data?.totalElements);

          setTimeout(() => {
            setLoading(false);
          }, 333);
        }
      })
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  // useEffect
  useEffect(() => {
    fetchData();
  }, [pageSize, pageNumber, statusOrder, reload]);

  useEffect(() => {
    setPageNumber(1)
    if (tab === "2") fetchData();
  }, [tab, filterApplied]);

  useEffect(() => {
    const topicId = location.state?.topicId;
    if (topicId) {
      setIsFirstTimes(false);
      form.setFieldsValue({
        topic: topicId,
      });

      setFilterData({
        ...filterData,
        topics: [topicId],
      });
    }
  }, [location.state?.topicId]);

  useEffect(() => {
    Promise.all([
      getTopicFilter({ code: "topic" }),
      getAllProductionUnit({ name: null }),
      getAllAuthor({ name: null }),
    ]).then((res) => {
      const listTopic = res[0].data.data.moocPortfolioValueData;
      const listUnit = res[1].data.data.map((unit: any) => {
        return ({
          id: unit.uuid,
          name: unit.name,
        })
      });
      const listAuthor = res[2].data.data;

      setDataOptions({
        ...dataOptions,
        dataTopic: listTopic,
        dataUnit: listUnit,
        dataAuthor: listAuthor,
      });
    });
  }, []);

  const fetchCourses = async () => {
    const payload = {
      pageNumber: 1,
      pageSize: 100000,
    }
    try {
      await postCourseSearch(payload).then((res) => {
        if (res.status === 201) {
          setCourseOptions(res.data.data.data);
        }
      })
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };
  const courseId = useWatch("course", form);
  useEffect(() => {
    form.setFieldsValue({
      section: null,
      sequence: null,
    })
    if (courseId) {
      fetchSection(courseId);
    }
  }, [courseId])

  const fetchSection = async (id: number) => {
    try {
      await getSectionByCourse(id).then((res) => {
        if (res.status === 200) {
          setSectionOptions(res.data);
        }
      })
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const sectionId = useWatch("section", form);
  useEffect(() => {
    form.setFieldsValue({
      sequence: null,
    })
    if (sectionId) {
      fetchSequence(sectionId);
    }
  }, [sectionId])

  const fetchSequence = async (id: number) => {
    try {
      await getSequenceBySection(id).then((res) => {
        if (res.status === 200) {
          setSequenceOptions(res.data);
        }
      })
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const callUseUnitBankToSequence = async (values: any) => {
    const payload = {
      sequenceId: values.sequence,
      bankId: selectedBankId,
    };
    try {
      await useUnitBankToSequence(payload);
      message.success(t("Đề đã được thêm thành công!", "Đề đã được thêm thành công!"));
    } catch (err) {
      message.error(t("Có lỗi xảy ra khi thêm đề.", "Có lỗi xảy ra khi thêm đề."));
      console.error(err);
    }
  };


  return (
    <Layout className="page-header-group bank-exam-list">
      <Form.Provider onFormFinish={(name, { values, forms }) => { }}>
        <div className="tabs-heading">
          <TableData
            dataTable={listDataExam}
            dataColumns={dataColumns}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            loadingTable={loading}
            scroll={{ x: 1500, y: 800 }}
            totalRecords={totalRecords}
            handleTableChangeProps={handleTableChange}
            pagination={true}
          />
        </div>
        <AddExamCourseModal onCancel={handleCancel} onFinish={handleOk} open={isModalOpen} courseOptions={courseOptions} sectionOptions={sectionOptions} sequenceOptions={sequenceOptions} form={form} />
      </Form.Provider>
    </Layout>
  );
};

export default BankExamList;
